import { EditOutlined } from '@ant-design/icons';
import * as Antd from 'antd';
import {
    Link,
    type To,
} from 'react-router-dom';

import { getActionControlStyleVars } from './actionControlStyles';

type ActionEditButtonProps = {
    onClick: React.MouseEventHandler<HTMLElement>;
    disabled?: boolean;
    tooltipTitle?: string;
    to?: To;
};

export const ActionEditButton = ({
    onClick,
    disabled,
    tooltipTitle = 'Редагувати',
    to,
}: ActionEditButtonProps) => {
    const { token } = Antd.theme.useToken();
    const styleVars = getActionControlStyleVars(token, {
        variant: 'text',
        bordered: true,
        iconOnly: true,
        disabled,
    });
    const icon = <EditOutlined style={{ fontSize: 16 }} />;

    if (to && !disabled) {
        return (
            <Antd.Tooltip title={tooltipTitle}>
                <Link
                    to={to}
                    aria-label={tooltipTitle}
                    className="app-action-control app-action-control--icon"
                    style={styleVars}
                >
                    {icon}
                </Link>
            </Antd.Tooltip>
        );
    }

    return (
        <Antd.Tooltip title={tooltipTitle}>
            <Antd.Button
                type="text"
                className="app-action-control app-action-control--icon"
                style={styleVars}
                icon={icon}
                onClick={onClick}
                disabled={disabled}
            />
        </Antd.Tooltip>
    );
};
